import React, {
  createContext,
  useContext,
  useState,
  useEffect,
  ReactNode,
} from 'react'
import type { Client } from '../api/generated/models'

interface ClientContextType {
  selectedClient: Client | null
  setSelectedClient: (client: Client | null) => void
}

interface ClientProviderProps {
  children: ReactNode
}

const ClientContext = createContext<ClientContextType | undefined>(undefined)

export const ClientProvider: React.FC<ClientProviderProps> = ({ children }) => {
  const [selectedClient, setSelectedClient] = useState<Client | null>(null)

  useEffect(() => {
    const storedClient = localStorage.getItem('client')

    if (storedClient && storedClient !== 'null') {
      setSelectedClient(JSON.parse(storedClient))
    }
  }, [])

  useEffect(() => {
    if (selectedClient) {
      localStorage.setItem('client', JSON.stringify(selectedClient))
    } else {
      localStorage.removeItem('client') // Remove the item instead of setting to "null"
    }
  }, [selectedClient])

  return (
    <ClientContext.Provider value={{ selectedClient, setSelectedClient }}>
      {children}
    </ClientContext.Provider>
  )
}

export const useClientContext = (): ClientContextType => {
  const context = useContext(ClientContext)

  if (context === undefined) {
    throw new Error('useClientContext must be used within a ClientProvider')
  }

  return context
}
